import React, { useMemo } from 'react'
import MealPlanForm from './_form'

export default function MealPlanAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <MealPlanForm data={data} {...props} />
  )
}